{
  "name": "@scalar/cli",
  "description": "A command-line interface to work with OpenAPI files",
  "keywords": [
    "scalar",
    "openapi",
    "swagger",
    "cli"
  ],
  "version": "1.7.4",
  "author": "Copyright API Documentation Inc. 2026",
  "license": "UNLICENSED",
  "private": true,
  "engines": {
    "node": ">=24"
  },
  "scripts": {
    "build": "vite-node esbuild.ts",
    "cli:link": "pnpm run build && npm unlink -g @scalar/cli && npm link",
    "dev": "pnpm build && dotenv -o -- pnpm start",
    "generate:docs": "pnpm build && pnpm start readme generate --output README.md",
    "start": "node dist-tar-unpack/index.js",
    "test:cli": "NODE_ENV=INTEGRATION dotenv -o -- vitest --config test/vitest.config.ts test/**",
    "test:unit": "vitest --config vite.config.ts src/**/*",
    "types:check": "scalar-types-check"
  },
  "type": "module",
  "exports": {
    ".": {
      "import": "./dist/index.js",
      "types": "./dist/index.d.ts",
      "default": "./dist/index.js"
    }
  },
  "files": [
    "dist"
  ],
  "homepage": "https://github.com/scalar/scalar",
  "bugs": "https://github.com/scalar/scalar/issues/new/choose",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/scalar/scalar.git",
    "directory": "projects/cli"
  },
  "bin": {
    "scalar": "./dist/index.js",
    "scalar-cli": "./dist/index.js"
  },
  "dependencies": {
    "@clack/prompts": "catalog:*",
    "@fastify/static": "catalog:*",
    "@hono/node-server": "1.19.7",
    "@scalar-org/api-reference-pro": "workspace:*",
    "@scalar-org/css": "workspace:*",
    "@scalar-org/entities": "workspace:*",
    "@scalar-org/guide-render": "workspace:*",
    "@scalar-org/helpers": "workspace:*",
    "@scalar-org/logger": "workspace:*",
    "@scalar-org/mongobase-client": "workspace:*",
    "@scalar-org/parser": "workspace:*",
    "@scalar-org/scalar-config": "workspace:*",
    "@scalar-org/service-api": "workspace:*",
    "@scalar-org/tokens": "workspace:*",
    "@scalar-org/urls": "workspace:*",
    "@scalar/json-magic": "catalog:scalar",
    "@scalar/mock-server": "catalog:scalar",
    "@scalar/oas-utils": "catalog:scalar",
    "@scalar/openapi-parser": "catalog:scalar",
    "@scalar/openapi-types": "catalog:scalar",
    "@scalar/themes": "catalog:scalar",
    "@scalar/void-server": "catalog:scalar",
    "@scalar/workspace-store": "catalog:scalar",
    "@stoplight/spectral-core": "catalog:*",
    "@stoplight/spectral-ruleset-bundler": "catalog:*",
    "@stoplight/spectral-rulesets": "catalog:*",
    "ansis": "catalog:*",
    "chokidar": "catalog:*",
    "commander": "catalog:*",
    "esbuild": "catalog:*",
    "fastify": "catalog:*",
    "get-port": "catalog:*",
    "hono": "4.12.4",
    "ignore": "catalog:*",
    "jsonc-parser": "catalog:*",
    "nanoid": "catalog:*",
    "neverpanic": "catalog:*",
    "prettyjson": "catalog:*",
    "semver": "catalog:*",
    "stdout-update": "catalog:*",
    "tailwindcss": "catalog:*",
    "tar-fs": "catalog:*",
    "undici": "catalog:*",
    "vite": "catalog:*"
  },
  "devDependencies": {
    "@fastify/static": "catalog:*",
    "@scalar-org/api-framework": "workspace:*",
    "@scalar-org/mongobase": "workspace:*",
    "@scalar-org/random-slug": "workspace:*",
    "@scalar-org/ssg-docs": "workspace:*",
    "@scalar/build-tooling": "catalog:scalar",
    "@scalar/galaxy": "catalog:scalar",
    "@types/node": "catalog:*",
    "@types/prettyjson": "catalog:*",
    "@types/semver": "catalog:*",
    "@types/tar-fs": "catalog:*",
    "strip-ansi": "catalog:*",
    "yaml": "catalog:*"
  }
}
